// extracted by mini-css-extract-plugin
export var body = "_dk-0";
export var sectionHeader = "_dk-4";
export var shortcutColumns = "_dk-2";
export var shortcutList = "_dk-1";
export var shortcutSection = "_dk-3";